<template>
	<div class="pt-22 plr-16 box-s">
    <div class="fz-14 fw-500 c1 mb-18">
      答题闯关
		</div>

		<ul class="flex">
			<li v-for="(item, index) in list" :key="index" class="wh_36 text-center l-h-36 b-radius-50 bb_fo mr-15 box-s every_a" :class="{ 'active':item.answer && item.answer.length != 0 }" @click="getQuest(item, index)">{{index + 1}}</li>

		</ul>

		<div class="btn_contain">
      <div class="blue_btn" @click="submit">
        提交
      </div>
    </div>
	</div>
</template>
<script>
	import { submitGateLevelQuestion } from '@/api/api.js'
	import { clear } from '@/utils/common'
	export default {
		components: {
		},
		data() {
			return {
       list: [],
			 num: 0
			};
		},
		created() {
			this.list = JSON.parse(this.$route.query.form)
			console.log(this.list,'this.list')
			this.list.forEach(item => {
        if(!item.answer.length){
					this.num = this.num + 1
				}
			})
		},
		methods: {
      async submit(){
				if(this.num){

          this.$dialog.confirm({
						title: '提示',
						message:
							`还有${this.num}道题未作答，是否提交答案？`,
					})
						.then(() => {
							this.getSubmit()
						})
						.catch(() => {
						});
				} else {
					this.getSubmit()
				}
				
			},
			async getSubmit(){
        const res = await submitGateLevelQuestion({answer: this.$route.query.form, gate_level_id: this.$route.query.id })
				if( res.code == 1000 ){
					this.$toast.success('答题完成')
					const form = res.data
					clear()
          setTimeout(()=>{
						this.$router.replace({ path: '/passreport', query: { id: this.$route.query.gate_level_user_id, answer_status: res.data.answer_status,cid: this.$route.query.id ,time_limit: this.$route.query.time_limit, form: JSON.stringify(form) } })
					}, 1000)
				} else {
            this.$toast(res.msg)
          }
			},
			getQuest(item, index){
				this.$router.replace({ path: '/passstartquset', query: { id: this.$route.query.id, form: this.$route.query.form, qusetNum: (index + 1),gate_level_user_id: this.$route.query.gate_level_user_id } })
			}
    }
	};
</script>
<style lang="less" scoped>
.active {
	border: 1px solid #497CFF;
	color: #497CFF;
}

.every_a:nth-child(7n){
	margin-right: 0 !important;
}
</style>
